import {
  AUFooter,
  BRFooter,
  EEAFooter,
  FRFooter,
  GlobalFooter,
  SGFooter,
  TRFooter,
  USFooter,
} from '@/modules/Footer'
import {
  AUNavbar,
  BRNavbar,
  EEANavbar,
  FRNavbar,
  GlobalNavbar,
  SGNavbar,
  TRNavbar,
  USNavbar,
} from '@/modules/NavBar'

export const useCommonComps = (layout: string) => {
  let Nav, Footer
  switch (layout) {
    case 'us':
      Nav = USNavbar
      Footer = USFooter
      break
    case 'eea':
      Nav = EEANavbar
      Footer = EEAFooter
      break
    case 'sg':
      Nav = SGNavbar
      Footer = SGFooter
      break
    case 'br':
      Nav = BRNavbar
      Footer = BRFooter
      break
    case 'au':
      Nav = AUNavbar
      Footer = AUFooter
      break
    case 'tr':
      Nav = TRNavbar
      Footer = TRFooter
      break
    case 'fr':
      Nav = FRNavbar
      Footer = FRFooter
      break
    default:
      Nav = GlobalNavbar
      Footer = GlobalFooter
      break
  }
  return { Nav, Footer }
}
